var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettlementCycleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0013 3.16663V0.666626L3.66797 3.99996L7.0013 7.33329V4.83329C9.75963 4.83329 12.0013 7.07496 12.0013 9.83329C12.0013 12.3083 10.193 14.3583 7.83463 14.7583V16.4416C11.1263 16.0333 13.668 13.2333 13.668 9.83329C13.668 6.14996 10.6846 3.16663 7.0013 3.16663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00065 9.83324C2.00065 8.45824 2.55898 7.20824 3.46732 6.29991L2.28398 5.11658C1.08398 6.32491 0.333984 7.99158 0.333984 9.83324C0.333984 13.2332 2.87565 16.0332 6.16732 16.4416V14.7582C3.80898 14.3582 2.00065 12.3082 2.00065 9.83324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlementCycleWhite);
export default __webpack_public_path__ + "static/media/settlement-cycle-white.b99d684dc8002dc6d8ccf21e14202d7b.svg";
export { ForwardRef as ReactComponent };